module.exports = __webpack_public_path__ + "img/our-vision.5a70ef37.svg";